const webaseConstants = {
    bgColorClasses: ['bg-', 'text-', 'hover:bg-', 'rounded', 'from', 'to', 'via', 'hover:text-', 'hover:from', 'hover:to', 'hover:via'],
    buttonBgColorClasses: ['bg-', 'text-', 'border', 'hover:bg-', 'hover:border-', 'rounded', 'from', 'to', 'via', 'hover:text-', 'hover:from', 'hover:to', 'hover:via'],
    templateTypes: ['Landing Page', 'Saas', 'Personal', 'Agency', 'Portfolio', 'Podcast', 'Splash Page']
}

export default webaseConstants
